var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "mt-0 mb-05" }, [
      this.data.post_text !== null && this.data.post_text !== ""
        ? _c("div", { staticClass: " pt-1 pb-1 col-12" }, [
            _c("div", {
              directives: [{ name: "linkified", rawName: "v-linkified" }],
              staticClass: "breakAll image-resize",
              domProps: { innerHTML: _vm._s(this.data.post_text) },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 p-0" }, [
        this.data.video_link !== null
          ? _c(
              "div",
              { staticClass: "text-center" },
              [_c("video-player", { attrs: { options: _vm.videoOptions } })],
              1
            )
          : this.data.video_external_url !== null
          ? _c("div", { staticClass: "video_container" }, [
              _c("iframe", {
                staticClass: "responsive-iframe",
                staticStyle: { "background-color": "#000" },
                attrs: {
                  webkitallowfullscreen: "",
                  mozallowfullscreen: "",
                  allowfullscreen: "",
                  src: this.data.video_external_url,
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.images.length > 1
          ? _c("div", { staticClass: "gallery-row" }, [
              _c(
                "div",
                { staticClass: "gallery-container" },
                [_c("lightbox", { attrs: { items: _vm.images } })],
                1
              ),
            ])
          : this.data.post_image.length === 1
          ? _c("div", [
              _c("div", { staticClass: "card-img-top text-center " }, [
                _c("img", {
                  staticClass: "mw-100",
                  attrs: { src: this.data.post_image[0].url },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        this.data.post_file.length > 0
          ? _c(
              "div",
              { staticClass: "pr-05 pl-05 pb-05 mt-1" },
              _vm._l(this.data.post_file, function (file, index) {
                return _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.downloadFile.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "download-button btn btn-primary waves-effect waves-light form-control",
                        attrs: {
                          "data-toggle": "modal",
                          "data-target": "#registerModal",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-download" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.__("resource.form.buttons.download")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }